module.exports = __webpack_public_path__ + "static/new-session-filters-041a9060508dbe2e1b6c4b1c7c890b32.png";